<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M4.125 19.625C5.57475 19.625 6.75 18.4497 6.75 17C6.75 15.5503 5.57475 14.375 4.125 14.375C2.67525 14.375 1.5 15.5503 1.5 17C1.5 18.4497 2.67525 19.625 4.125 19.625Z"
        stroke="white" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M18.75 4.25L22.5 8L18.75 11.75" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
    <path
        d="M6.75 17H7.50001C8.69348 17 9.83807 16.5259 10.682 15.682C11.5259 14.8381 12 13.6935 12 12.5V12.5C12 11.3065 12.4741 10.1619 13.318 9.31802C14.1619 8.47411 15.3065 8 16.5 8H22.5"
        stroke="white" stroke-linecap="round" stroke-linejoin="round" />
</svg>